import i18next from 'i18next';

i18next.addResources('es_CL', 'NPSFormMessageValidation', {
  completeAll: 'Debe responder todas las encuestas.'
});
